import { render, staticRenderFns } from "./destination-advice-accordian.vue?vue&type=template&id=67e61c46"
import script from "./destination-advice-accordian.vue?vue&type=script&lang=js"
export * from "./destination-advice-accordian.vue?vue&type=script&lang=js"
import style0 from "./destination-advice-accordian.vue?vue&type=style&index=0&id=67e61c46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports